import { render, staticRenderFns } from "./MessageTypeFilter.vue?vue&type=template&id=49a5eef2"
import script from "./MessageTypeFilter.vue?vue&type=script&lang=js"
export * from "./MessageTypeFilter.vue?vue&type=script&lang=js"
import style0 from "./MessageTypeFilter.vue?vue&type=style&index=0&id=49a5eef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports